<template>
  <div class="login-box">
    <div class="login-logo">
      <a href="#">
        <img src="/assets/img/brand-mark.svg" alt="شعار أحمد المحيسني العقارية" class="login-brand-mark mb-2">
        <br>
          <span>أحمد المحيسني العقارية</span>
        <br>
          <small style="font-size: 18px;">خلف كل رقم، عقد، أو متابعة توجد قيمة تُبنى<br/>أنجز بذكاء، واترك للنظام ترتيب التفاصيل</small>
      </a>
    </div>
    <!-- /.login-logo -->
    <div class="card">
      <div class="card-body login-card-body">
        <p class="login-box-msg">تسجيل الدخول</p>
        <form action="" method="post" @submit.prevent="submitLogin()">
          <errorAlert v-if="loginErorr" :alertMessage="message" />
          <div class="input-group mb-3">
            <input type="email" class="form-control" placeholder="Email" v-model="email" />
            <div class="input-group-text">
              <span class="bi bi-envelope"></span>
            </div>
          </div>
          <div class="input-group mb-3">
            <input
              type="password"
              class="form-control"
              placeholder="Password" 
              v-model="password"
            />
            <div class="input-group-text">
              <span class="bi bi-lock-fill"></span>
            </div>
          </div>
          <!--begin::Row-->
          <div class="row">
            <div class="col">
              <loader v-if="isLoading" />
              <div v-else class="d-grid gap-2">
                <button type="submit" class="btn btn-primary">تسجيل الدخول</button>
              </div>
            </div>
            <!-- /.col -->
          </div>
          <!--end::Row-->
        </form>
      </div>
      <!-- /.login-card-body -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getRandomInt } from '@/helpers/tools';

export default {
  name: "Login",
  computed: {
    ...mapGetters(['GET_USER']),
  },
  data() {
    return {
      isLoading: false,
      loginErorr: false,
      message: "",
      password: "",
      email: "",
      filedType: "password",
    };
  },
  methods: {
    submitLogin() {
      this.loginErorr = false;
      this.isLoading = true;
      if(this.email.trim() == '' || this.password.trim() == ''){
        this.message = 'يرجى كتابة بيانات الدخول';
        this.loginErorr = true;
        this.isLoading = false;
        return false;
      }

      let deviceToken = localStorage.getItem('deviceToken');
      if(!deviceToken){
        deviceToken = `${crypto.randomUUID()}-${getRandomInt(1000, 99999)}`;
        localStorage.setItem('deviceToken', deviceToken);
      }
      
      this.$http
        .post("api/admin/auth/login", {
          email: this.email.trim(),
          password: this.password,
          deviceToken: deviceToken,
        })
        .then((res) => {
          localStorage.setItem('userToken', res.data.admin.token);
          this.$store.commit("SET_USER_DATA", res.data.admin);
          // console.log(res);
          this.loginErorr = false;
          this.isLoading = false;
          // Redirect to the home page
          setTimeout(() => {
            window.location.href = "/";
          }, 500);
        })
        .catch((err) => {
          // console.log(err);
          this.message = this.$globalError(err);
          this.loginErorr = true;
          this.isLoading = false;
          window.scroll(0, 0);
        });
    },
    togglePassword() {
      this.filedType = this.filedType === "password" ? "text" : "password";
    },
  },
  created(){
    if(this.GET_USER){
      window.location.href = '/';
    }
  }
};
</script>

<style scoped>
input {
  text-align: left;
}
</style>
